import React from 'react';
import styled from 'styled-components';

export const BrowserImg = styled.div`
  position: relative;
  top: 4px;
  left: 4px;
  width: 56px;
  height: 56px;
  background-size: cover;
  background-image: ${({browserName}) => `url(/images/icons/browsers/${browserName}-color.svg)`};
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 22px;
  max-width: 150px;
  text-align: center;
`;

export const Line = styled.div`
  align-self: flex-start;
  font-size: 12px;
  font-weight: normal;
  margin-bottom: 18px;
  max-width: 280px;
`;

export const CTA = styled.a`
  width: calc(100% - 16px);
  padding: 8px;
  margin-top: 5px;
  text-align: center;
  color: #fff;
  background-color: #4a8af4;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
  cursor: pointer;
`;
